export class ActionCard3D{

    constructor(data) {
        let spec_dict={0:"green",1:"blue",2:"purple",3:"orange"};
        this.specular=spec_dict[data.RANK];
        this.loader=new Three.TextureLoader();
        this.streamerImagePath=`/api/images/cards/streamer_images/${data["STID"]}/${data.RANK}.png`
        this.cardFrontImagePath=`/api/images/cards/activity/bg.png`;
        this.cardBackImagePath=`/api/images/cards/activity/back.png`;
        this.cardDecoratorImagePath=`/api/images/cards/activity/${data.RANK}.png`
        this.streamerImage=null;
        this.cardFrontImage=null;
        this.cardBackImage=null;
        this.cardNormalFrontImage=null;
        this.cardDecoratorImage=null;
        this.floatX=data.FLOAT_X;
        this.floatY=data.FLOAT_Y;
        this.shininess=1;
        this.ctx=null;
        this.loadFrontImage(this.cardFrontImagePath);

        this.loadStreamerImage(this.streamerImagePath);
        this.loadDecoratorImage(this.cardDecoratorImagePath);
        this.loadBackImage(this.cardBackImagePath);
        this.loadNormals();
        this.createFrontMaterial();
        this.createStreamerMaterial();
        this.createDecoratorMaterial();
        this.createBackMaterial();



    }
    loadNormals(){
        this.cardNormalFrontImage=this.loader.load("/api/images/lenormal.png");



    }

    loadFrontImage(imagePath){
        this.cardFrontImage=this.loader.load(imagePath,
            function(){
            },
            function(){
            },
            function(){
            });
    }
    loadStreamerImage(imagePath){
        let self=this;
        this.streamerImage=this.loader.load(imagePath,
            function(){
            },
            function(){
            },
            function(){
                self.loadStreamerImage("/api/images/cards/streamer_images/NO_IMAGE.png")
            });
    }
    loadDecoratorImage(imagePath){
        this.cardDecoratorImage=this.loader.load(imagePath);
    }

    loadBackImage(imagePath){
        this.cardBackImage=this.loader.load(imagePath);
    }




    createFrontMaterial(){
        this.frontMaterial = new Three.MeshPhongMaterial({map:this.cardFrontImage,transparent: true,shininess:25*this.shininess});

    }
    createStreamerMaterial(){
        this.streamerMaterial = new Three.MeshPhongMaterial({map:this.streamerImage,transparent: true,shininess:50*this.shininess});

    }
    createDecoratorMaterial(){
        this.decoratorMaterial = new Three.MeshPhongMaterial({map:this.cardDecoratorImage,transparent: true,shininess:100*this.shininess,specular:this.specular});
    }

    createBackMaterial(){


        this.backMaterial = new Three.MeshPhongMaterial({map:this.cardBackImage,transparent: true,shininess:25*this.shininess});
        this.backMaterial.side = Three.BackSide;
    }

    animateUse(){
        var video = document.createElement('video');

        var source = document.createElement('source');

        source.setAttribute('src', '/api/images/card_used_smoke.webm');

        video.appendChild(source);
        video.muted=true;
        video.play();

        const texture = new Three.VideoTexture(video);
        texture.minFilter = Three.LinearFilter;
        texture.magFilter = Three.LinearFilter;
        texture.format = Three.RGBAFormat;

        const geometry = new Three.BoxGeometry(6.4, 8.9,0.03);
        const materiala = new Three.MeshBasicMaterial({ map: texture});
        materiala.transparent=true;
        //materiala.opacity=0.5;

        const plane = new Three.Mesh(geometry, materiala);
        plane.material.side = Three.DoubleSide;
        this.card.add(plane);



    }

    render(){

        this.geometry_front = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );
        this.geometry_front_decorator = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );

        this.geometry_side = new Three.BoxGeometry( 6.4, 8.9, 0.01 );
        this.material_side = new Three.MeshBasicMaterial( { color: 0x000000 } );
        this.cube_side = new Three.Mesh( this.geometry_side, this.material_side );

        this.geometry_front_image = new Three.PlaneBufferGeometry( 4.8, 3.35, 1, 1 );

        this.geometry_front.dynamic=true;
        this.geometry_front_decorator.dynamic=true;
        let geometry_back = new Three.PlaneBufferGeometry( 6.4, 8.9, 1, 1 );
        geometry_back.dynamic=true;


        this.backMaterial.normalMap=this.cardNormalFrontImage;
        this.backMaterial.normalScale=new Three.Vector2( 0, 0.5 );
        this.backMaterial.transparent=true;

        this.decoratorMaterial.normalMap=this.cardNormalFrontImage;
        this.decoratorMaterial.normalScale=new Three.Vector2( 0, 0.5 );

        this.frontMaterial.normalMap=this.cardNormalFrontImage;
        this.frontMaterial.normalScale=new Three.Vector2( 0, 0.5 );


        var canvas = document.createElement('canvas');
        this.ctx = canvas.getContext('2d');

        canvas.width = 800;
        canvas.height = 300;


        this.ctx.font = '45px/1.8 merienda, sans-serif';

        this.ctx.textAlign = "left";
        this.ctx.fillStyle = '#ffffff';
        //ctx.fillText("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", 14,42);


        this.text_texture = new Three.CanvasTexture(canvas);


        let material = new Three.MeshPhongMaterial({map: this.text_texture,transparent: true,shininess:100});
        //let material = new Three.SpriteMaterial({map: texture});
        let geometry_text= new Three.PlaneBufferGeometry( 5, 2.1, 1,1 );
        this.mesh3= new Three.Mesh( geometry_text, material);
        this.mesh3.position.z+=0.014;
        this.mesh3.position.y=-2.32;



        this.card = new Three.Object3D();



        this.card.buffersNeedUpdate = true;
        this.card.needsUpdate = true;

        this.geometry_front.clearGroups();
        this.geometry_front.addGroup( 0, Infinity, 0 );
        //this.geometry_front.addGroup( 0, Infinity, 1 );
        //geometry_back.applyMatrix( new Three.Matrix4().makeRotationY( Math.PI ) );
        let mesh1 = new Three.Mesh( this.geometry_front, this.frontMaterial );
        let mesh5 = new Three.Mesh( this.geometry_front_decorator, this.decoratorMaterial );



        let mesh2 = new Three.Mesh( geometry_back, this.backMaterial );
        mesh1.position.z+=0.010;
        mesh2.position.z-=0.010;
        this.mesh4 = new Three.Mesh( this.geometry_front_image, this.streamerMaterial);
        this.mesh4.position.z+=0.011;
        mesh5.position.z+=0.012;
        this.mesh4.position.y+=1.64;



        this.card.add( mesh1 );
        this.card.add( mesh2 );
        this.card.add( this.mesh4 );
        this.card.add( mesh5 );
        this.card.add( this.cube_side );
        this.card.add(this.mesh3);
        return this.card
    }

    updateText(text){
        this.wrapText(this.ctx,text,25,70,750,50);
        this.text_texture.needsUpdate=true;
    }

    wrapText (context, text, x, y, maxWidth, lineHeight) {
        context.clearRect(0,0,800,300);
        text=text.replace(/\n/g, ' \\n ');
        text=text.replace(/\r/g, ' \\n ');

        var words = text.split(' '),
            line = '',
            i,
            test,
            metrics;

        for (i = 0; i < words.length; i++) {
            test = words[i];
            if (test==="\\n"){
                console.log("hmm");
                context.fillText(line, x, y);
                line = words[i] + ' ';
                y += lineHeight;
                line='';


            }
            else{
                metrics = context.measureText(test);
                while (metrics.width > maxWidth) {
                    // Determine how much of the word will fit
                    test = test.substring(0, test.length - 1);
                    metrics = context.measureText(test);
                }
                if (words[i] !== test) {
                    words.splice(i + 1, 0,  words[i].substr(test.length))
                    words[i] = test;
                }

                test = line + words[i] + ' ';
                metrics = context.measureText(test);

                if (metrics.width > maxWidth && i > 0) {
                    context.fillText(line, x, y);
                    line = words[i] + ' ';
                    y += lineHeight;
                }
                else {
                    line = test;
                }}
        }

        context.fillText(line, x, y);
    }



}
import * as Three from 'three'

